(() => {
  const panel = document.querySelector('[data-cookie-panel]');
  if (!panel || panel.dataset.mounted) return;
  panel.dataset.mounted = 'true';
  const html = document.documentElement;
  const settings = panel.querySelector('[data-cookie-settings]');
  const choices = panel.querySelector('#mt-cookie-choices');
  const save = panel.querySelector('[data-cookie-save]');
  const close = panel.querySelector('[data-cookie-close]');
  const status = panel.querySelector('[data-cookie-status]');
  const controls = [...panel.querySelectorAll('button,input')];
  const purposes = ['preferences', 'analytics', 'marketing'];
  let api, busy = false, returnFocus, requestedOpen = false, timer;
  const selected = () => Object.fromEntries(purposes.map(key => [key, panel.querySelector('input[name="' + key + '"]').checked]));
  const consent = () => api.currentVisitorConsent();
  const hasChoice = value => purposes.every(key => value[key] === 'yes' || value[key] === 'no');
  function expand(value) {
    choices.hidden = !value; save.hidden = !value;
    settings.setAttribute('aria-expanded', String(value));
    settings.textContent = value ? 'Zwiń ustawienia' : 'Dostosuj ustawienia';
  }
  function show(manual = false) {
    const state = api ? consent() : {};
    purposes.forEach(key => { panel.querySelector('input[name="' + key + '"]').checked = state[key] === 'yes'; });
    expand(manual); close.hidden = !manual;
    panel.hidden = false; html.classList.add('mt-consent-open');
    if (manual) panel.querySelector('h2').focus();
  }
  function hide() {
    panel.hidden = true; html.classList.remove('mt-consent-open');
    if (returnFocus?.isConnected) returnFocus.focus();
    returnFocus = null;
  }
  function setBusy(value) {
    busy = value; controls.forEach(el => { el.disabled = value; });
    panel.setAttribute('aria-busy', String(value));
  }
  function failed() {
    clearTimeout(timer); setBusy(false);
    html.classList.remove('mt-consent-ready');
    status.textContent = 'Nie udało się zapisać wyboru. Spróbuj ponownie lub odśwież stronę.';
  }
  function commit(value) {
    if (busy || !api) return;
    setBusy(true); status.textContent = 'Zapisuję wybór…';
    timer = setTimeout(failed, 8000);
    try {
      api.setTrackingConsent(value, result => {
        clearTimeout(timer);
        try {
          if (result?.error) return failed();
          const actual = consent();
          if (!purposes.every(key => actual[key] === (value[key] ? 'yes' : 'no'))) return failed();
          setBusy(false); status.textContent = '';
          html.classList.add('mt-consent-ready'); hide();
        } catch (_) { failed(); }
      });
    } catch (_) { failed(); }
  }
  panel.querySelector('[data-cookie-reject]').addEventListener('click', () => commit({preferences:false,analytics:false,marketing:false}));
  panel.querySelector('[data-cookie-accept]').addEventListener('click', () => commit({preferences:true,analytics:true,marketing:true}));
  save.addEventListener('click', () => commit(selected()));
  settings.addEventListener('click', () => expand(choices.hidden));
  close.addEventListener('click', hide);
  panel.addEventListener('keydown', event => { if (event.key === 'Escape' && !busy && !close.hidden) hide(); });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-cookie-open]');
    if (!trigger) return;
    returnFocus = trigger; requestedOpen = true;
    if (api) { status.textContent = ''; show(true); }
    else {
      show(true); status.textContent = 'Ustawienia cookies są chwilowo niedostępne. Odśwież stronę i spróbuj ponownie.';
      panel.querySelectorAll('[data-cookie-reject],[data-cookie-accept],[data-cookie-save]').forEach(el => { el.disabled = true; });
      load();
    }
  });
  function ready() {
    const candidate = window.Shopify?.customerPrivacy;
    if (!candidate?.setTrackingConsent || !candidate?.currentVisitorConsent || !candidate?.shouldShowBanner) return;
    try {
      api = candidate;
      const state = consent(), required = api.shouldShowBanner();
      html.classList.add('mt-consent-ready'); setBusy(false); status.textContent = '';
      if (requestedOpen) show(true);
      else if (required && !hasChoice(state)) show();
    } catch (_) { api = null; html.classList.remove('mt-consent-ready'); }
  }
  let loading = false, attempts = 0;
  function load() {
    if (loading) return;
    if (window.Shopify?.customerPrivacy) return ready();
    if (window.Shopify?.loadFeatures) {
      loading = true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
        loading = false;
        if (!error) ready();
      });
    } else if (++attempts <= 20) setTimeout(load, 250);
  }
  load();
})();
